// Service to fetch project data for the map
// This will eventually connect to Supabase to get data from the admin panel

export interface ProjectLocation {
  id: string
  name: string
  address: string
  coordinates: [number, number] // [lng, lat]
  projectType: string
  description?: string
  year?: string
}

class ProjectService {
  /**
   * Fetch all projects with location data for the map
   * TODO: Replace with actual Supabase query when backend is ready
   */
  async getProjectsForMap(): Promise<ProjectLocation[]> {
    try {
      // For now, return empty array - will be populated by admin data
      // When Supabase is connected, this will query the projects table
      // and transform the data to match ProjectLocation interface
      
      // Example of what the Supabase query will look like:
      // const { data, error } = await supabase
      //   .from('projects')
      //   .select('id, name, address_street, address_city, address_lat, address_lng, project_type, description, year')
      //   .not('address_lat', 'is', null)
      //   .not('address_lng', 'is', null)
      
      return []
    } catch (error) {
      console.error('Error fetching projects for map:', error)
      return []
    }
  }

  /**
   * Transform admin project data to map format
   * This will be used when connecting to Supabase
   */
  transformProjectData(adminProject: any): ProjectLocation {
    return {
      id: adminProject.id.toString(),
      name: adminProject.name,
      address: `${adminProject.address_street}, ${adminProject.address_city}`,
      coordinates: [adminProject.address_lng, adminProject.address_lat],
      projectType: adminProject.project_type || 'Project',
      description: adminProject.description,
      year: adminProject.year
    }
  }
}

export const projectService = new ProjectService()
